import React, { useEffect } from "react";
import ReactDOM from "react-dom";

import Icon from "../Icon";

import Styles from "./addProductPopin.module.scss";
import { IAddProductPopin } from "./addProductPopin.interface";

export const AddProductPopin: React.FC<IAddProductPopin> = ({
  active = false,
  title,
  onClose,
  onSubmit,
}) => {
  useEffect(
    function lockBodyScroll() {
      if (!active) return;
      document.body.style.overflow = "hidden";
      return function unlockBodyScroll() {
        document.body.style.overflow = "";
      };
    },
    [active],
  );

  useEffect(
    function handleKeyboard() {
      if (!active) return;
      function onKeyDown(e: KeyboardEvent) {
        if (e.key === "Escape") onClose?.();
      }
      document.addEventListener("keydown", onKeyDown);
      return function removeKeyboardListener() {
        document.removeEventListener("keydown", onKeyDown);
      };
    },
    [active, onClose],
  );

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    onSubmit(data.get("productName") as string, data.get("brand") as string);
    e.currentTarget.reset();
  };

  return ReactDOM.createPortal(
    <div
      className={`${Styles["addProductPopin__container"]} ${
        active ? Styles["is-active"] : ""
      }`}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div className={Styles["addProductPopin__underlay"]} onClick={onClose} />
      <div className={Styles["addProductPopin__popin"]}>
        <div className={Styles["addProductPopin__header"]}>
          <p className={Styles["addProductPopin__title"]}>{title}</p>
          <button
            className={Styles["addProductPopin__close"]}
            onClick={onClose}
            aria-label="Fermer"
          >
            <Icon icon="cross" />
          </button>
        </div>
        <div className={Styles["addProductPopin__content"]}>
          <form onSubmit={handleSubmit} className={Styles.addProductForm}>
            <label htmlFor="productName" className={Styles.addProductForm__label}>
              Nom du produit
            </label>
            <input
              type="text"
              id="productName"
              name="productName"
              required
              className={Styles.addProductForm__input}
            />
            <label htmlFor="brand" className={Styles.addProductForm__label}>
              Marque
            </label>
            <input
              type="text"
              id="brand"
              name="brand"
              required
              className={Styles.addProductForm__input}
            />
            <div className={Styles.addProductForm__actions}>
              <button
                type="button"
                onClick={onClose}
                className={Styles.addProductForm__cancel}
              >
                Annuler
              </button>
              <input
                type="submit"
                value="Ajouter"
                className={Styles.addProductForm__submit}
              />
            </div>
          </form>
        </div>
      </div>
    </div>,
    document.body,
  );
};
